exports.graphQLEndpoint = process.env.GRAPHQL_ENDPOINT || '/api/v1';
